"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crewUpdate = void 0;
var planck_js_1 = require("planck-js");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageJettison_sidecar_1 = require("@voyage/multi/voyageMessageJettison-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    d.useSystemTimer += ds;
    var useSystemTime = 0.5;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        if (voyageSystems_sidecar_1.voyageSystems.testNoPower(obj)) {
            return;
        }
        var tHere = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
        if (tHere) {
            var sysTarget = voyageTilemap_sidecar_1.voyageTilemap.getSystemByKeySafe(('' + tHere.text3).replace('ejectrol', 'ejector'));
            var ejectionPoint = voyageTilemap_sidecar_1.voyageTilemap.getSystemByKeySafe(('' + tHere.text3).replace('ejectrol', 'ejp'));
            if (sysTarget) {
                var targetCrew = diveCrew_sidecar_1.diveCrew.getAtIIJ(sysTarget, function (c) {
                    return c.type === diveCrew_1.EVoyageCrewType.Hero || c.type === diveCrew_1.EVoyageCrewType.Enemy;
                });
                // if (targetCrew) {
                //   if (voyageWebsockets.getIsHost()) {
                //     voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
                //       crewId: targetCrew.id,
                //       byCrewId: 0,
                //       newHitpoints: 0,
                //       type: EVoyageCrewDamageType.Jettison,
                //     })
                //   }
                // }
                // // Testing!
                // let id = voyageMessageCrewCarry.sendCreateMessageAndImmediatelyExecute({
                //   type: EVoyageCarryableType.Medpack,
                //   i: sysTarget.i,
                //   j: sysTarget.j,
                // })
                // let testCy = voyageCarryable.findById(id)
                // assert.notNil(testCy)
                // voyageCarryable.setAtTile(testCy, sysTarget)
                var x_1 = sysTarget.x;
                var y_1 = sysTarget.y;
                var dx_1 = -1;
                var dy_1 = 0;
                if (ejectionPoint) {
                    x_1 = ejectionPoint.x;
                    y_1 = ejectionPoint.y;
                    var v = planck_js_1.Vec2(ejectionPoint.x - sysTarget.x, ejectionPoint.y - sysTarget.y);
                    v.normalize();
                    dx_1 = v.x;
                    dy_1 = v.y;
                }
                if (sysTarget.items.length > 0) {
                    imports_1.l.forEach(sysTarget.items, function (c) {
                        voyageMessageJettison_sidecar_1.voyageMessageJettison.sendMessageAndImmediatelyExecute({
                            carryableId: c.id,
                            crewId: 0,
                            x: x_1,
                            y: y_1,
                            dx: dx_1,
                            dy: dy_1,
                        });
                    });
                }
            }
        }
    }
}
exports.crewUpdate = crewUpdate;
